import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1dde86ed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Rapidly build beautiful and accessible experiences. The Carbon kit contains all resources you need to get started.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Get the kit</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Support</AnchorLink>
    </AnchorLinks>
    <h2>{`Get the kit`}</h2>
    <p>{`The Adobe XD is a work in progress and once finished it will be available as an Adobe Creative Cloud (CC) Library. Until then download the file and use it as a sticker sheet.`}</p>
    <h4>{`1. Install Adobe XD`}</h4>
    <p>{`To design with Carbon you must have the most recent version of `}<a parentName="p" {...{
        "href": "https://www.adobe.com/products/xd.html"
      }}>{`Adobe XD`}</a>{` installed.`}</p>
    <h4>{`2. Download the kit`}</h4>
    <p>{`The Adobe XD kit is currently only available in the White theme.`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Get the Adobe XD Design kit" href="https://github.com/IBM/design-kit/raw/master/Adobe%20XD/Carbon%20Design%20System%20-%20V10%20-%20White%20(11.01.19).xd" actionIcon="download" mdxType="ResourceCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "615px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "97.56097560975611%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADY0lEQVQ4y6VVa2jNYRh/drDUGGObmcu57XLsds7ZXFKGsk0091vIxAgJGaJMbkU+KFIkxUh8dJ0kzRGzzDXJXGdLsy2X3C/L3p/nec7/rOPDVvjX07/3eZ/39/6e60sYdKsQKYEHdY6TrTUDy8wT+1Hz2F4mgvYlaMO2+Og+9xGemwe/J12MJvk+uc9jRdQkeMlh/OTE34iPz+Ta0hDouxtIrby8rcd8GwlYPHVvySI7siLsJpPsJoMGiiCThXX6zwgTXhuxlTOplGhcFN9a1W8f4KkuI2HmFTAGSqE+Jp36CVtZKxDrkE79YdmoZNAABkqQv8mJcBs7xWJrj6JWeKoMCfV03sju7DYzPAUY1cunAAKW0yUJohsZ41WdsBWwoV1TMTV5DIZHpSkRJ8WhNHqOQep1Boxw6k0C8OjUTTwvvwd/Jxfs1BO7izcDTz6h0DFSGQ2OTFbGRdmTgedfsTp/IZIpzrhZtyl6LgNWGvIxQ6/Nybf0UgO8B1blLWDDeHy504hTO44quFwiukSKwjz/JKC+BSVjFyGJ3RXA0nBADT7HZhAlovbCfdw+XoGtM9cAz74gP2EYPNRXZfmoeag6cgkNFY+B2u8oKSgWhiFAyTQUUDLnt7ngot7K0tR8QMvDdzi8dg8bx6qbGwqXAc3AtUPlOL3zWJBhR4BeK3ucHDQGngJNwIIh0/QScfdNZS0zv4JY6owpnBDU/7Rcbo8hH5I4rhu/BD8fvMW3e80IHDgLB8Ugr88Q4NUv7F2yHXEUiaUjZgN1HQBmWkUsDJuuPtVElE5ZCbwDZmeMV9bC6PjG/ehGxEmZCLz8gdXtucxZViZbZpSoq9NS8rTuPt95jbsnArpXfewy8OIbFg+fifUSz9dGvQnLchBQ6pAPm8FcxA0VNajYf4YzmqCx21W0EWgwmJ8zGaN7+/GCa1RAJWFyWfGw6VqfrvCyCXYKA3LRTuACli4Q1zOtuBbacxksW2vQG+HArPRxekFuzyy14/PGwSw3hQNKs4tY/dnWswIqujTub58tGGsBlkSITmw4ZH+2ngwH2eCyMczAhAZDSHzMKqTz6tqp4MJW+jibXH8Oh/DxZY2ttvHVgaiNMPZY4+tGaHyFBqzvPwbsFWvAMksbBZ+Aq//8BHzQJ6C67Qn4DXjV6a76vrqDAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "adobe xd",
              "title": "adobe xd",
              "src": "/static/370ff0000cad5185abfd7a0bdbfad05e/83210/adobe-xd.png",
              "srcSet": ["/static/370ff0000cad5185abfd7a0bdbfad05e/7fc1e/adobe-xd.png 288w", "/static/370ff0000cad5185abfd7a0bdbfad05e/a5df1/adobe-xd.png 576w", "/static/370ff0000cad5185abfd7a0bdbfad05e/83210/adobe-xd.png 615w"],
              "sizes": "(max-width: 615px) 100vw, 615px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Support`}</h2>
    <p>{`If you’re brand new to Adobe XD, they offer some great `}<a parentName="p" {...{
        "href": "https://helpx.adobe.com/xd/tutorials.html"
      }}>{`tutorials`}</a>{`.`}</p>
    <h3>{`Releases`}</h3>
    <p>{`Enhancements to the kit will be rolling out in the future. When a new version of the library is available, you will need to download the new file to replace the old one. Releases will be posted to the `}<a parentName="p" {...{
        "href": "https://github.com/IBM/design-kit"
      }}>{`GitHub repo`}</a></p>
    <h3>{`Help`}</h3>
    <p>{`Can’t find an answer to your question? Open an issue on `}<a parentName="p" {...{
        "href": "https://github.com/IBM/design-kit/issues/new?assignees=&labels=kit%3A+adobe+xd&template=-adobe-xd--carbon-kit.md&title=%5Bcomponent%5D+description+of+issue"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      